import LogHandler from "./LogHandler";
/**
 * 全局的日志状态管理
 */
export const logHandler = new LogHandler();
//# sourceMappingURL=index.js.map
